import { Component, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/common';
import { NotificationService } from 'notification';
import { environment } from '../environments/environment';

import { ApiService } from 'profile';
import { LayoutService } from './core/services/layout.service';
import { AuthService } from './core/services/auth.service';
import { PlatformService } from './core/services/platform.service';
import { PrivacyPolicyService } from 'privacy-policy';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'DHHP';
  userPrinciblename: string;
  dataSource: any;
  appParam:any;
  imagUrl: any;
  profileName;
  fullName: string;
  constructor(
    private route: ActivatedRoute, 
    private translate: TranslateService, 
    private apiService: ApiService, 
    private dataService: LayoutService,
    private auth: AuthService,
    private privacyService:PrivacyPolicyService,
    @Inject(DOCUMENT) private document: Document,
    private _http: PlatformService, 
    private notifyService: NotificationService) { }
  ngOnInit(): void {
    // if (localStorage.getItem('Lang') == null) {
    //   this.translate.use('en')
    // }
    // // this.apiService.apiUrl = environment.PLATFORM_AUTH;
    // this.appParam = this.GetParam('code');
    // if(this.appParam){
    //   this.dataService.signInPHusr.next(this.appParam);
    // }
    // // for notification start
    // this.userPrinciblename = this.auth.getToken();
    // this.notifyService.apiUrl = environment.PLATFORM_AUTH;
    // this.apiService.apiUrl = environment.PLATFORM_AUTH;
    // this.apiService.apiUrlPrivacyPolicy = environment.API_ENDPOINT_Facility;
    // this.privacyService.apiUrl = environment.PLATFORM_AUTH;
    // this.privacyService.apiUrlPrivacyPolicy = environment.API_ENDPOINT_Facility;
    // this.privacyService.appID = environment.appId;
  
    // //this.dataService.getRoleValue = this.auth.getRole();
    // if(this.auth.getRole()){
    //   this.getFeaturesData(this.auth.getRole());
    // }
    // if (this.auth.getUserToken()) {
    //   this.apiService.getUserProfile(this.auth.getUserToken()).subscribe((data: any) => {
    //     this.imagUrl = data.profileImage;
    //     this.dataService.getProfileData.next(data);
    //     this.dataService.facilityAccount.next(data.facilityAccounts[0]);
    //     //this.getFeaturesData(data.dhhpRoleId);
        
    //     this.dataService.getUserRole = data.dhhpRole;
    //     this.dataService.getRoleValue = data.dhhpRole;
    //   })
    // }
  }
  getFeaturesData(roleId) {
    if (roleId != '')
      this._http.getRoleProfileById(roleId).subscribe({
        next:res=>{
          if(res){
            this.dataService.getProfileRoleData.next(res.features);
            this.dataService.userRoleData = res.features;
            this.dataService.getRoleValueAccess.next(true);
          }
        },
        error: err=>{
          if(!!err && err.status==500){
            //this.dhhpAlert.dhhpAlertError(err.error.message, '')
           }
        }
      })
    
  }
  GetParam(name){
    const results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(this.document.location.href);
    if(!results){
      return 0;
    }
    return results[1] || 0;
  }
}
